import { useEffect, useState } from "react";
import Aside from "../../components/Aside";
import CustomDataTable from "../../components/CustomDataTable";
import Footer from "../../components/Footer";
import Header from "../../components/Header";
import { AccountService } from "../../services/AccountsService";
import AccountFormModal from "./AccountFormModal";
import { useTranslation } from "react-i18next";
import useRequest from "../../hooks/useRequest";
function AccountsPage() {

    const { t } = useTranslation();
    const {call, isRequesting} = useRequest();
    const columns = [
        {
            name: 'ID',
            sortable: true,
            selector: row => <p className="text-nowrap p-0">{row.account_id}</p>,
        },
        {
            name: t("platform.accounts.name"),
            sortable: true,
            selector: row => <p className="text-nowrap p-0">{row.name}</p>,
        },
        {
            name: t("platform.accounts.licenses"),
            sortable: true,
            center: true,
            selector: row => row.licenses,
        },
        {
            name: t("platform.accounts.number-standard"),
            sortable: true,
            center: true,
            selector: row => row.waweb_number,
        },
        {
            name: t("platform.accounts.last-update"),
            sortable: true,
            center: true,
            selector: row => <p className="text-nowrap p-0">{row.waweb_last_update}</p>,
        },
        {
            name: t("platform.accounts.server-standard"),
            sortable: true,
            center: true,
            selector: row => row.waweb_server,
        },
        {
            name: t("platform.accounts.status-whatsapp"),
            sortable: true,
            center: true,
            selector: row => row.waweb_status,
        },
        {
            name: t("platform.accounts.number-waba"),
            sortable: true,
            center: true,
            selector: row => row.waba_number,
        },
        {
            name: t("platform.accounts.provider-waba"),
            sortable: true,
            center: true,
            selector: row => row.waba_provider,
        },
        {
            name: t("platform.accounts.quality-waba"),
            sortable: true,
            center: true,
            selector: row => row.waba_qualyty,
        },
        {
            name: t("platform.accounts.status-waba"),
            sortable: true,
            center: true,
            selector: row => row.waba_status,
        },
        {
            name: t("platform.accounts.waba-id"),
            sortable: true,
            center: true,
            selector: row => row.waba_wab_id,
        },
        {
            name: t("platform.accounts.sms-credits"),
            sortable: true,
            center: true,
            selector: row => row.sms_credits,
        },
        {
            name: t("platform.accounts.sms-status"),
            sortable: true,
            center: true,
            selector: row => row.sms_status,
        },
        {
            name:t("platform.accounts.bot-status"),
            sortable: true,
            center: true,
            selector: row => row.bot_status,
        },
               
        {
            name: t("platform.accounts.actions"),
            sortable: false,
            center: true,
            cell: (row) => {
                return (
                    <div className="btn-group" role="group">
                        <button className="btn bg-soft-info-alternative btn-sm text-white-dark" onClick={() => setModalForm({ show: true, type: 'licences', data: row })}>
                            {t("platform.accounts.add-licenses")}
                        </button>
                        <div className="btn-group">
                            <button type="button" className="btn bg-soft-info-alternative btn-icon btn-sm dropdown-toggle dropdown-toggle-empty"  data-bs-toggle="dropdown" aria-expanded="false"></button>

                            <div className="dropdown-menu dropdown-menu-end mt-1" >
                                <button className="dropdown-item" onClick={() => setModalForm({ show: true, type: 'waweb', data: row })}>
                                    <i className="bi bi-box-arrow-in-up me-3 text-white-dark"></i>  {t("platform.accounts.enable-disable")}
                                </button>
                                
                            </div>
                        </div>

                    </div>
                )
            }
        },
    ];

    const [modalForm, setModalForm] = useState<any>({
        show: false,
        type: 'create',
        data: null,
    })
    const [rows, setRows] = useState([])

    const getAccounts = async() => {
        const { data } = await call(AccountService.getAccountByRoot);
        setRows(data)
    }

    const handleHideModal = async(refresh) => {
        if(refresh) {
            await getAccounts();
        }

        setModalForm({
            show: false,
            type: 'create',
            data: null,
        })
    }

    useEffect(() => {
        getAccounts()
    }, [])
    

    return (
        <>
            <Header />
            <Aside />

            <main id="content" role="main" className="main">

                <div className="content container-fluid">

                    <div className="page-header">
                        <div className="row align-items-center">
                            <div className="col-sm mb-2 mb-sm-0">
                                <nav aria-label="breadcrumb">
                                    <ol className="breadcrumb breadcrumb-no-gutter">
                                        <li className="breadcrumb-item "><span className="breadcrumb-link" >{t("platform.platform-title")}</span></li>
                                        <li className="breadcrumb-item active" aria-current="page">{t("platform.accounts.accounts-title")}</li>
                                    </ol>
                                </nav>
                                <h1 className="page-header-title text-white-dark"><i className="bi-folder-plus text-primary"></i> {t("platform.accounts.accounts-title")}</h1>
                            </div>
                            <div className="col-sm-auto">
                                <button className="btn btn-primary" onClick={ () => setModalForm({ show: true, type: 'create', data: null }) }><i className="bi-plus-lg me-1"></i> {t("platform.accounts.add-account")}</button>
                            </div>
                        </div>
                    </div>

                    <CustomDataTable
                        columns={columns}
                        data={rows}
                        hideAccountsFilter
                        showExport={false}
                        isLoading={isRequesting}
                        filter={(row, term) => {
                            if (!term) return true;

                            return (
                                `${row.bot_status}`.match(new RegExp(`${term}`, 'i')) ||
                                `${row.licenses}`.match(new RegExp(`${term}`, 'i')) ||
                                `${row.name}`.match(new RegExp(`${term}`, 'i')) ||
                                `${row.sms_credits}`.match(new RegExp(`${term}`, 'i')) ||
                                `${row.sms_status}`.match(new RegExp(`${term}`, 'i')) ||
                                `${row.wab_limit}`.match(new RegExp(`${term}`, 'i')) ||
                                `${row.wab_sendToday}`.match(new RegExp(`${term}`, 'i')) ||
                                `${row.waba_number}`.match(new RegExp(`${term}`, 'i')) ||
                                `${row.waba_phone_id}`.match(new RegExp(`${term}`, 'i')) ||
                                `${row.waba_provider}`.match(new RegExp(`${term}`, 'i')) ||
                                `${row.waba_qualyty}`.match(new RegExp(`${term}`, 'i')) ||
                                `${row.waba_status}`.match(new RegExp(`${term}`, 'i')) ||
                                `${row.waba_wab_id}`.match(new RegExp(`${term}`, 'i')) ||
                                `${row.waweb_last_update}`.match(new RegExp(`${term}`, 'i')) ||
                                `${row.waweb_number}`.match(new RegExp(`${term}`, 'i')) ||
                                `${row.waweb_server}`.match(new RegExp(`${term}`, 'i')) ||
                                `${row.waweb_status}`.match(new RegExp(`${term}`, 'i'))
                            )
                        }}
                    />

                </div>
                <Footer />
            </main>

            <AccountFormModal 
                show={modalForm.show}
                type={modalForm.type}
                data={modalForm.data}
                onRequestClose={(refresh) => handleHideModal(refresh)}
            />
        </>
    )
}

export default AccountsPage